module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/guest_list-7f7e16f9357e3f954a1ff69d80de80bd.png";